// extracted by mini-css-extract-plugin
export var cancelButton = "xmCh7";
export var hide = "RVRqX";
export var searchContainer = "SZv4f";
export var wide = "kPLef";